const projectData = [
  {
    id: 1,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/Crockery+1.png",
    sections: [
      {
        name: "Wall Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73538,
            label: 1,
            name: "Open Box",
            dimensions: "1200 x 450 x 350",
            color: "21027 SF",
            minfix: true,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "1202",
          },
          {
            id: 73539,
            label: 2,
            name: "Open Box",
            dimensions: "1500 x 450 x 350",
            color: "21027 SF",
            minfix: true,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "1202",
          },
          {
            id: 73540,
            label: 3,
            name: "3 Door Unit",
            dimensions: "900 x 1350 x 350",
            color: "21027 SF",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "1003",
          },
          {
            id: 73541,
            label: 4,
            name: "Open Box",
            dimensions: "300 x 1350 x 350",
            color: "21027 SF",
            minfix: true,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "1202",
          },
        ],
      },
      {
        name: "Base Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73542,
            label: 5,
            name: "1D Floor Unit",
            dimensions: "700 x 450 x 550",
            color: "21027 SF",
            minfix: true,
            position: {
              left: 0.25,
              top: 0.25,
            },
            sku: "0401",
          },
          {
            id: 73543,
            label: 6,
            name: "2D Floor Unit",
            dimensions: "700 x 900 x 550",
            color: "21027 SF",
            minfix: false,
            position: {
              left: 0.3,
              top: 0.3,
            },
            sku: "0402",
          },
          {
            id: 73544,
            label: 7,
            name: "2D Floor Unit",
            dimensions: "700 x 900 x 550",
            color: "21027 SF",
            minfix: true,
            position: {
              left: 0.35,
              top: 0.35,
            },
            sku: "0402",
          },
          {
            id: 73546,
            label: 8,
            name: "Top Panel (18mm)",
            dimensions: "18 x 2250 x 550",
            color: "21027 SF",
            minfix: false,
            position: {
              left: 0.4,
              top: 0.4,
            },
            sku: "1303",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/Wardrobe+3.png",
    sections: [
      {
        name: "Loft",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73569,
            label: 1,
            name: "2D Loft",
            dimensions: "600 x 900 x 118",
            color: "21039 SF",
            minfix: false,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "0801",
          },
          {
            id: 73570,
            label: 2,
            name: "1D Loft",
            dimensions: "600 x 600 x 118",
            color: "21039 SF",
            minfix: false,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "0802",
          },
          {
            id: 73571,
            label: 3,
            name: "2D Loft",
            dimensions: "600 x 900 x 118",
            color: "21039 SF",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "0801",
          },
        ],
      },
      {
        name: "Wardrobe",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73572,
            label: 4,
            name: "2 Door Sliding Wardrobe",
            dimensions: "2000 x 1800 x 550",
            color: "21039 SF",
            minfix: true,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "0301",
          },
          {
            id: 73576,
            label: 5,
            name: "Open Box",
            dimensions: "600 x 600 x 550",
            color: "14538 VNR",
            minfix: false,
            position: {
              left: 0.25,
              top: 0.25,
            },
            sku: "1202",
          },
          {
            id: 73578,
            label: 6,
            name: "2 Drawer",
            dimensions: "150 x 600 x 550",
            color: "14538 VNR",
            minfix: false,
            position: {
              left: 0.3,
              top: 0.3,
            },
            sku: "1007",
          },
        ],
      },
    ],
  },
  {
    id: 5,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/Wardrobe+2.png",
    sections: [
      {
        name: "Loft",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73579,
            label: 1,
            name: "2D Loft",
            dimensions: "600 x 900 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "0801",
          },
          {
            id: 73581,
            label: 2,
            name: "2D Loft",
            dimensions: "600 x 900 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "0801",
          },
          {
            id: 73583,
            label: 3,
            name: "1D Loft",
            dimensions: "600 x 580 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "0802",
          },
        ],
      },
      {
        name: "Wardrobe",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73584,
            label: 4,
            name: "2D Wardrobe",
            dimensions: "2000 x 900 x 550",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "0111",
          },
          {
            id: 73585,
            label: 5,
            name: "2 Drawer",
            dimensions: "500 x 580 x 550",
            color: "5517 SUD",
            minfix: false,
            position: {
              left: 0.25,
              top: 0.25,
            },
            sku: "1007",
          },
          {
            id: 73586,
            label: 6,
            name: "2D Wardrobe",
            dimensions: "2000 x 900 x 550",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.3,
              top: 0.3,
            },
            sku: "0111",
          },
          {
            id: 73587,
            label: 7,
            name: "Open Box",
            dimensions: "1500 x 580 x 550",
            color: "5517 SUD",
            minfix: false,
            position: {
              left: 0.35,
              top: 0.35,
            },
            sku: "1202",
          },
        ],
      },
    ],
  },
  {
    id: 6,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/Wardrobe+1.png",
    sections: [
      {
        name: "Loft",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73592,
            label: 1,
            name: "2D Loft",
            dimensions: "600 x 1100 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "0801",
          },
          {
            id: 73593,
            label: 2,
            name: "2D Loft",
            dimensions: "600 x 1100 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "0801",
          },
        ],
      },
      {
        name: "Wardrobe",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73598,
            label: 3,
            name: "2D Wardrobe",
            dimensions: "2000 x 900 x 550",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "0111",
          },
          {
            id: 73599,
            label: 4,
            name: "1D Wardrobe",
            dimensions: "2000 x 450 x 550",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "0206",
          },
          {
            id: 73600,
            label: 5,
            name: "Open Box",
            dimensions: "2000 x 300 x 550",
            color: "14538 VNR",
            minfix: false,
            position: {
              left: 0.25,
              top: 0.25,
            },
            sku: "1202",
          },
        ],
      },
    ],
  },
  {
    id: 7,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/TV+Unit+2.png",
    sections: [
      {
        name: "Tall Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73607,
            label: 1,
            name: "Open Box",
            dimensions: "2000 x 450 x 450",
            color: "14538 VNR",
            minfix: true,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "1202",
          },
        ],
      },
      {
        name: "Base Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73605,
            label: 2,
            name: "2 Drawer",
            dimensions: "400 x 600 x 450",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "1007",
          },
          {
            id: 73606,
            label: 3,
            name: "2 Drawer",
            dimensions: "400 x 600 x 450",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "1007",
          },
          {
            id: 73608,
            label: 4,
            name: "2 Drawer",
            dimensions: "400 x 600 x 450",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "1007",
          },
          {
            id: 73609,
            label: 5,
            name: "27mm Vertical Ledge - Double Side Exposed",
            dimensions: "750 x 27 x 450",
            color: "14538 VNR",
            minfix: false,
            position: {
              left: 0.25,
              top: 0.25,
            },
            sku: "1406",
          },
          {
            id: 73610,
            label: 6,
            name: "27mm Ledge - Double Side Exposed",
            dimensions: "27 x 1827 x 450",
            color: "14538 VNR",
            minfix: false,
            position: {
              left: 0.3,
              top: 0.3,
            },
            sku: "1405",
          },
        ],
      },
    ],
  },
  {
    id: 8,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/TV+Unit+1.png",
    sections: [
      {
        name: "Base Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73614,
            label: 1,
            name: "2 Drawer",
            dimensions: "400 x 800 x 450",
            color: "21039 SF",
            minfix: false,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "1007",
          },
          {
            id: 73615,
            label: 2,
            name: "2D Floor Unit",
            dimensions: "400 x 650 x 450",
            color: "21039 SF",
            minfix: false,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "0402",
          },
          {
            id: 73616,
            label: 3,
            name: "2 Drawer",
            dimensions: "400 x 800 x 450",
            color: "21039 SF",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "1007",
          },
        ],
      },
      {
        name: "Wall Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73621,
            label: 4,
            name: "Kitchen 2D Tall Unit",
            dimensions: "1500 x 650 x 350",
            color: "21039 SF",
            minfix: true,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "0423",
          },
        ],
      },
    ],
  },
  {
    id: 9,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/Kitchen+4.png",
    sections: [
      {
        name: "Loft",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73624,
            label: 1,
            name: "2D Loft",
            dimensions: "450 x 733 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "0801",
          },
          {
            id: 73625,
            label: 2,
            name: "1D Loft",
            dimensions: "450 x 300 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "0802",
          },
          {
            id: 73626,
            label: 3,
            name: "1D Loft",
            dimensions: "450 x 650 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "0802",
          },
          {
            id: 73627,
            label: 4,
            name: "1D Loft",
            dimensions: "450 x 566 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "0802",
          },
        ],
      },
      {
        name: "Wall Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73630,
            label: 5,
            name: "1D Wall Unit",
            dimensions: "900 x 300 x 350",
            color: "22091 SF",
            minfix: true,
            position: {
              left: 0.25,
              top: 0.25,
            },
            sku: "0501",
          },
          {
            id: 73631,
            label: 6,
            name: "2D Wall Unit",
            dimensions: "900 x 733 x 350",
            color: "22091 SF",
            minfix: true,
            position: {
              left: 0.3,
              top: 0.3,
            },
            sku: "0502",
          },
          {
            id: 73632,
            label: 7,
            name: "1D Loft",
            dimensions: "600 x 650 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.35,
              top: 0.35,
            },
            sku: "0802",
          },
          {
            id: 73633,
            label: 8,
            name: "1D Wall Unit",
            dimensions: "900 x 366 x 350",
            color: "21027 SF",
            minfix: false,
            position: {
              left: 0.4,
              top: 0.4,
            },
            sku: "0501",
          },
          {
            id: 73634,
            label: 9,
            name: "Open Box",
            dimensions: "900 x 200 x 175",
            color: "14538 VNR",
            minfix: false,
            position: {
              left: 0.45,
              top: 0.45,
            },
            sku: "1202",
          },
        ],
      },
      {
        name: "Base Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73635,
            label: 10,
            name: "1D Sink Unit",
            dimensions: "700 x 500 x 550",
            color: "22122 SF",
            minfix: false,
            position: {
              left: 0.5,
              top: 0.5,
            },
            sku: "0403",
          },
          {
            id: 73639,
            label: 11,
            name: "1D Floor Unit",
            dimensions: "700 x 300 x 550",
            color: "22122 SF",
            minfix: false,
            position: {
              left: 0.55,
              top: 0.55,
            },
            sku: "0401",
          },
          {
            id: 73640,
            label: 12,
            name: "2 Tandem Box Unit",
            dimensions: "700 x 650 x 550",
            color: "22122 SF",
            minfix: false,
            position: {
              left: 0.6,
              top: 0.6,
            },
            sku: "0408",
          },
          {
            id: 73641,
            label: 13,
            name: "2 Tandem Box Unit",
            dimensions: "700 x 600 x 550",
            color: "22122 SF",
            minfix: false,
            position: {
              left: 0.65,
              top: 0.65,
            },
            sku: "0408",
          },
          {
            id: 73642,
            label: 14,
            name: "Bottle Pullout Unit",
            dimensions: "700 x 200 x 550",
            color: "22122 SF",
            minfix: false,
            position: {
              left: 0.7,
              top: 0.7,
            },
            sku: "0410",
          },
        ],
      },
    ],
  },
  {
    id: 10,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/Kitchen+3.png",
    sections: [
      {
        name: "Base Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73643,
            label: 1,
            name: "2 Tandem Box Unit",
            dimensions: "700 x 600 x 550",
            color: "1174",
            minfix: true,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "0408",
          },
          {
            id: 73644,
            label: 2,
            name: "2 Tandem Box Unit",
            dimensions: "700 x 600 x 550",
            color: "1174",
            minfix: false,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "0408",
          },
          {
            id: 73648,
            label: 3,
            name: "3 Tandem Box Unit",
            dimensions: "700 x 600 x 550",
            color: "1174",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "0409",
          },
          {
            id: 73649,
            label: 4,
            name: "1D Floor Unit",
            dimensions: "700 x 450 x 550",
            color: "1174",
            minfix: false,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "0401",
          },
          {
            id: 73653,
            label: 5,
            name: "2D Floor Unit",
            dimensions: "700 x 900 x 550",
            color: "1174",
            minfix: false,
            position: {
              left: 0.25,
              top: 0.25,
            },
            sku: "0402",
          },
          {
            id: 73654,
            label: 6,
            name: "2 Tandem Box Unit",
            dimensions: "700 x 600 x 550",
            color: "1174",
            minfix: true,
            position: {
              left: 0.3,
              top: 0.3,
            },
            sku: "0408",
          },
        ],
      },
      {
        name: "Wall Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73655,
            label: 7,
            name: "2D Wall Unit",
            dimensions: "900 x 900 x 350",
            color: "22091 SF",
            minfix: true,
            position: {
              left: 0.35,
              top: 0.35,
            },
            sku: "0502",
          },
          {
            id: 73656,
            label: 8,
            name: "Open Box",
            dimensions: "900 x 650 x 350",
            color: "21039 SF",
            minfix: false,
            position: {
              left: 0.4,
              top: 0.4,
            },
            sku: "1202",
          },
          {
            id: 73657,
            label: 9,
            name: "2D Wall Unit",
            dimensions: "900 x 900 x 350",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.45,
              top: 0.45,
            },
            sku: "0502",
          },
          {
            id: 73658,
            label: 10,
            name: "2D Wall Unit",
            dimensions: "450 x 900 x 350",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.5,
              top: 0.5,
            },
            sku: "0502",
          },
          {
            id: 73659,
            label: 11,
            name: "2D Wall Unit",
            dimensions: "450 x 900 x 350",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.55,
              top: 0.55,
            },
            sku: "0502",
          },
          {
            id: 73660,
            label: 12,
            name: "2D Wall Unit",
            dimensions: "900 x 900 x 350",
            color: "22091 SF",
            minfix: true,
            position: {
              left: 0.6,
              top: 0.6,
            },
            sku: "0502",
          },
        ],
      },
    ],
  },
  {
    id: 11,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/Kitchen+2.png",
    sections: [
      {
        name: "Wall Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73670,
            label: 1,
            name: "2D Wall Unit",
            dimensions: "750 x 900 x 300",
            color: "21027 SF",
            minfix: false,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "0502",
          },
          {
            id: 73671,
            label: 2,
            name: "2D Wall Unit",
            dimensions: "750 x 900 x 300",
            color: "21027 SF",
            minfix: true,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "0502",
          },
          {
            id: 73672,
            label: 3,
            name: "2D Wall Unit",
            dimensions: "750 x 900 x 300",
            color: "21027 SF",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "0502",
          },
          {
            id: 73673,
            label: 4,
            name: "Kitchen 1D Tall Unit",
            dimensions: "1350 x 450 x 550",
            color: "21027 SF",
            minfix: true,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "0422",
          },
          {
            id: 73674,
            label: 5,
            name: "2D Wall Unit",
            dimensions: "750 x 900 x 300",
            color: "21027 SF",
            minfix: false,
            position: {
              left: 0.25,
              top: 0.25,
            },
            sku: "0502",
          },
          {
            id: 73676,
            label: 6,
            name: "36mm Ledge - Double Side Exposed",
            dimensions: "36 x 900 x 300",
            color: "14538 VNR",
            minfix: false,
            position: {
              left: 0.3,
              top: 0.3,
            },
            sku: "1411",
          },
        ],
      },
      {
        name: "Base Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73661,
            label: 7,
            name: "1D Floor Unit",
            dimensions: "700 x 450 x 550",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.35,
              top: 0.35,
            },
            sku: "0401",
          },
          {
            id: 73662,
            label: 8,
            name: "2D Floor Unit",
            dimensions: "700 x 1050 x 550",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.4,
              top: 0.4,
            },
            sku: "0402",
          },
          {
            id: 73663,
            label: 9,
            name: "3 Tandem Box Unit",
            dimensions: "700 x 600 x 550",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.45,
              top: 0.45,
            },
            sku: "0409",
          },
          {
            id: 73665,
            label: 10,
            name: "1D Sink Unit",
            dimensions: "700 x 600 x 550",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.5,
              top: 0.5,
            },
            sku: "0403",
          },
          {
            id: 73667,
            label: 11,
            name: "3 Tandem Box Unit",
            dimensions: "700 x 600 x 550",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.55,
              top: 0.55,
            },
            sku: "0409",
          },
          {
            id: 73668,
            label: 12,
            name: "2D Floor Unit",
            dimensions: "700 x 900 x 550",
            color: "22091 SF",
            minfix: true,
            position: {
              left: 0.6,
              top: 0.6,
            },
            sku: "0402",
          },
        ],
      },
    ],
  },
  {
    id: 12,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/Kitchen+1.png",
    sections: [
      {
        name: "Loft",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73677,
            label: 1,
            name: "2D Loft",
            dimensions: "400 x 1050 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "0801",
          },
          {
            id: 73680,
            label: 2,
            name: "2D Loft",
            dimensions: "400 x 1050 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "0801",
          },
          {
            id: 73681,
            label: 3,
            name: "1D Loft",
            dimensions: "400 x 600 x 118",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "0802",
          },
        ],
      },
      {
        name: "Wall Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73683,
            label: 4,
            name: "1D Flap Unit",
            dimensions: "400 x 600 x 350",
            color: "22091 SF",
            minfix: true,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "0503",
          },
          {
            id: 73685,
            label: 5,
            name: "2D Wall Unit",
            dimensions: "750 x 1050 x 350",
            color: "22091 SF",
            minfix: true,
            position: {
              left: 0.25,
              top: 0.25,
            },
            sku: "0502",
          },
          {
            id: 73686,
            label: 6,
            name: "2D Wall Unit",
            dimensions: "750 x 1050 x 350",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.3,
              top: 0.3,
            },
            sku: "0502",
          },
        ],
      },
      {
        name: "Base Unit",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73687,
            label: 7,
            name: "2 Tandem Box Unit",
            dimensions: "700 x 600 x 550",
            color: "22091 SF",
            minfix: true,
            position: {
              left: 0.35,
              top: 0.35,
            },
            sku: "0408",
          },
          {
            id: 73688,
            label: 8,
            name: "2D Sink Unit",
            dimensions: "700 x 900 x 550",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.4,
              top: 0.4,
            },
            sku: "0404",
          },
          {
            id: 73689,
            label: 9,
            name: "2D Floor Unit",
            dimensions: "700 x 1100 x 550",
            color: "22091 SF",
            minfix: false,
            position: {
              left: 0.45,
              top: 0.45,
            },
            sku: "0402",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/Wardrobe+5.png",
    sections: [
      {
        name: "Loft",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73548,
            label: 1,
            name: "2D Loft",
            dimensions: "600 x 900 x 118",
            color: "1174",
            minfix: false,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "0801",
          },
          {
            id: 73550,
            label: 2,
            name: "2D Loft",
            dimensions: "600 x 900 x 118",
            color: "1174",
            minfix: false,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "0801",
          },
        ],
      },
      {
        name: "Wardrobe",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73551,
            label: 3,
            name: "1D Wardrobe",
            dimensions: "2000 x 450 x 550",
            color: "1174",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "0206",
          },
          {
            id: 73552,
            label: 4,
            name: "2D Wall Unit",
            dimensions: "650 x 900 x 550",
            color: "1174",
            minfix: false,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "0502",
          },
          {
            id: 73553,
            label: 5,
            name: "Open Box",
            dimensions: "650 x 900 x 550",
            color: "14538 VNR",
            minfix: false,
            position: {
              left: 0.25,
              top: 0.25,
            },
            sku: "1202",
          },
          {
            id: 73554,
            label: 6,
            name: "3 Drawer",
            dimensions: "700 x 900 x 550",
            color: "1174",
            minfix: false,
            position: {
              left: 0.3,
              top: 0.3,
            },
            sku: "1008",
          },
          {
            id: 73555,
            label: 7,
            name: "1D Wardrobe",
            dimensions: "2000 x 450 x 550",
            color: "1174",
            minfix: false,
            position: {
              left: 0.35,
              top: 0.35,
            },
            sku: "0206",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/Sample+Projects/Wardrobe+4.png",
    sections: [
      {
        name: "Wardrobe",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73562,
            label: 1,
            name: "1D Wardrobe",
            dimensions: "2000 x 450 x 550",
            color: "9857 AFX",
            minfix: false,
            position: {
              left: 0.05,
              top: 0.05,
            },
            sku: "0206",
          },
          {
            id: 73563,
            label: 2,
            name: "2D Wardrobe",
            dimensions: "2000 x 900 x 550",
            color: "9857 AFX",
            minfix: false,
            position: {
              left: 0.1,
              top: 0.1,
            },
            sku: "0111",
          },
        ],
      },
      {
        name: "Loft",
        specs: {
          Material: "WPC",
          Hardware: "Blum",
        },
        modules: [
          {
            id: 73566,
            label: 3,
            name: "1D Loft",
            dimensions: "600 x 450 x 118",
            color: "9857 AFX",
            minfix: false,
            position: {
              left: 0.15,
              top: 0.15,
            },
            sku: "0802",
          },
          {
            id: 73567,
            label: 4,
            name: "2D Loft",
            dimensions: "600 x 900 x 118",
            color: "9857 AFX",
            minfix: false,
            position: {
              left: 0.2,
              top: 0.2,
            },
            sku: "0801",
          },
        ],
      },
    ],
  },
];
export default projectData;
